<template>
  <div>
    <div class="isis-modal-header">
      <h3 class="title">{{ $t("class.behavior") }}: {{ student.full_name }}</h3>
      <div class="flex">
        <button
          v-if="
            mode === 'view' && $can(Behavior.actions.edit, Behavior.subject)
          "
          class="btn-close mr-5"
          @click.prevent="mode = 'edit'"
        >
          <md-icon class="text-[#FF9801]">edit</md-icon>
        </button>
        <button class="btn-close" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <validation-form @on-submit="fetchBehavior" class="validation-form">
      <div class="md-layout">
        <div class="form-item md-layout-item md-size-100 p-0">
          <p>{{ $t("behavior.violation_in_time") }}</p>
          <div class="md-layout-item md-size-100 md-layout p-0 lg:gap-[10%]">
            <div class="md-layout-item md-size-45 md-small-size-100 p-0">
              <md-field>
                <label>{{ $t("common.term") }}</label>
                <md-select v-model="behavior.term_id">
                  <md-option
                    v-for="(term, termIndex) in termList"
                    :key="termIndex + 'term'"
                    :value="term.id"
                  >
                    {{ term.name }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-100 p-0">
              <validation-field
                :validations="{ required: true }"
                name="datetime violate"
                type="date-time-picker"
              >
                <template #default="{ errors }">
                  <date-time-picker
                    :label="$t('behavior.datetime_violate')"
                    v-model="behavior.date_violate"
                    required
                  >
                    <span class="md-error">{{ errors[0] }}</span>
                    <span
                      class="md-error"
                      v-if="serverValidations.date_violate"
                    >
                      {{ serverValidations.date_violate }}
                    </span>
                  </date-time-picker>
                </template>
              </validation-field>
            </div>
          </div>
        </div>
        <div class="form-item md-layout-item md-size-100 p-0">
          <p>{{ $t("behavior.information_about_violation") }}</p>
          <div class="md-layout-item md-size-100 md-layout p-0 lg:gap-[10%]">
            <div class="md-layout-item md-size-45 md-small-size-100 p-0">
              <validation-field
                :validations="validations.submitted_by"
                name="submitted by"
              >
                <label>{{ $t("behavior.submitted_by") }}</label>
                <md-input
                  required
                  type="text"
                  v-model.trim="behavior.submitted_by"
                  autocomplete="off"
                ></md-input>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-100 p-0">
              <md-field>
                <label>{{ $t("behavior.alignment") }}</label>
                <md-select v-model="behavior.alignment">
                  <md-option
                    v-for="(alignment, index) in alignments"
                    :key="index + 'alignment'"
                    :value="alignment.id"
                  >
                    {{ alignment.name }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-100 p-0">
              <md-field>
                <label>{{ $t("schedule.location") }}</label>
                <md-input
                  type="text"
                  v-model.trim="behavior.location"
                  autocomplete="off"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-100 p-0">
              <validation-field :validations="validations.event" name="event">
                <label>{{ $t("schedule.event") }}</label>
                <md-input
                  required
                  type="text"
                  v-model.trim="behavior.event"
                  autocomplete="off"
                ></md-input>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-100 p-0">
              <validation-field>
                <label>{{ $t("behavior.injury") }}</label>
                <md-input
                  type="text"
                  v-model.trim="behavior.injury"
                  autocomplete="off"
                ></md-input>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-100 p-0">
              <validation-field>
                <label>{{ $t("behavior.medical_service_provided") }}</label>
                <md-input
                  type="text"
                  v-model.trim="behavior.medical_service_provided"
                  autocomplete="off"
                ></md-input>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-100 mb-4 p-0">
              <label> {{ $t("behavior.incident_detail") }}</label>
              <div class="border border-gray-300  pb-2">
                <md-field>
                  <md-textarea
                    class="p-0"
                    v-model="behavior.incident_detail"
                  ></md-textarea>
                </md-field>
              </div>
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100 p-0">
              <md-field class="p-0" v-if="mode !== 'view'">
                <label>{{ $t("behavior.upload_file") }}</label>
                <md-file @md-change="upLoadFile($event)" multiple></md-file>
              </md-field>
              <div
                class="mb-4 md-layout-item md-size-100 md-layout md-small-size-100 p-0"
                v-if="
                  mode !== 'add' &&
                    behaviorData.file_upload &&
                    behaviorData.file_upload.length
                "
              >
                <label>{{ $t("behavior.file_upload") }}</label>
                <p
                  class="md-layout-item md-size-100 p-0"
                  v-for="(file, index) in behaviorData.file_upload"
                  :key="index + 'filename'"
                >
                  {{ index + 1 }}. {{ file.slice(file.lastIndexOf("/") + 1) }}
                </p>
              </div>
            </div>
            <div class="md-layout-item md-size-100 mb-4 p-0">
              <label> {{ $t("behavior.participant_details") }}</label>
              <div class="border border-gray-300 pb-2">
                <md-field>
                  <md-textarea
                    class="p-0"
                    v-model="behavior.participant_detail"
                  ></md-textarea>
                </md-field>
              </div>
            </div>
          </div>
        </div>
        <div
          class="form-item md-layout-item md-size-100 md-layout p-0 lg:gap-[10%]"
          v-for="(item, index) in resolutionList"
          :key="index + 'resolution'"
        >
          <div class="md-layout-item md-size-100 md-layout bg-[#eee] mx-2 p-1">
            <span class="md-layout-item md-size-80 p-0"
              >{{ $t("behavior.resolution") }} {{ index + 1 }}</span
            >
            <span
              v-if="index !== 0 && mode !== 'view'"
              class="md-layout-item md-size-20 text-right my-auto p-1"
              ><i class="fas fa-times" @click="removeResolution(index)"></i
            ></span>
          </div>
          <div class="md-layout-item md-size-45 md-small-size-100 mt-2 p-0">
            <validation-field
              :validations="validations.resolution"
              name="resolution"
            >
              <label>{{ $t("behavior.resolution") }}</label>
              <md-input
                required
                type="text"
                v-model="item.resolution"
              ></md-input>
            </validation-field>
          </div>
          <div class="md-layout-item md-size-45 md-small-size-100 mt-2 p-0">
            <date-picker-custom
              :label="$t('behavior.assign_date')"
              v-model="item.assign_date"
            >
              <span
                class="md-error"
                v-if="serverValidations[`resolution.${index}.assign_date`]"
              >
                {{ serverValidations[`resolution.${index}.assign_date`] }}
              </span>
            </date-picker-custom>
          </div>
          <div class="md-layout-item md-size-45 md-small-size-100 mt-2 p-0">
            <date-time-picker
              :label="$t('common.start_date')"
              v-model="item.start_date"
            >
              <span
                class="md-error"
                v-if="serverValidations[`resolution.${index}.start_date`]"
              >
                {{ serverValidations[`resolution.${index}.start_date`] }}
              </span>
            </date-time-picker>
          </div>
          <div class="md-layout-item md-size-45 md-small-size-100 mt-2 p-0">
            <date-time-picker
              :label="$t('common.end_date')"
              v-model="item.end_date"
            >
              <span
                class="md-error"
                v-if="serverValidations[`resolution.${index}.end_date`]"
              >
                {{ serverValidations[`resolution.${index}.end_date`] }}
              </span>
            </date-time-picker>
          </div>
          <div class="md-layout-item md-size-45 md-small-size-100 mt-2 p-0">
            <validation-field
              :validations="validations.staffId"
              :name="'staff ' + (index + 1)"
              type="autocomplete"
              style="margin-bottom: 0px !important"
            >
              <template #default="{ errors }">
                <isis-autocomplete
                  required
                  v-model="staffs.displayValue[index]"
                  :value.sync="resolutionList[index].staff_id"
                  :options.sync="staffs.options"
                  :refetchOptions="getStaffs"
                  :search-key="staffs.searchKey"
                  :fields="staffs.fields"
                  :label="staffs.label"
                  :class="{ 'md-invalid': !!errors.length }"
                  fetchOnOpen
                >
                  <span class="md-error" style="top:35px">{{ errors[0] }}</span>
                </isis-autocomplete>
              </template>
            </validation-field>
          </div>
          <div class="md-layout-item md-size-100 mb-4 p-0">
            <label> {{ $t("behavior.resolution_details") }}</label>
            <div class="border border-gray-300 pb-2">
              <md-field>
                <md-textarea
                  class="p-0"
                  v-model="resolutionList[index].resolution_detail"
                ></md-textarea>
              </md-field>
            </div>
          </div>
        </div>
        <span
          v-if="mode !== 'view'"
          class="form-item pl-8 text-[#345FB4] cursor-pointer"
          @click="addResolution()"
          >{{ $t("behavior.add_resolution") }}</span
        >
        <div class="form-item md-layout-item md-size-100">
          <div class="form-actions text-right">
            <md-button class="md-raised" @click="closeModal">{{
              $t("common.cancel")
            }}</md-button>
            <md-button
              v-if="mode !== 'view'"
              type="submit"
              class="md-success ml-4"
              >{{
                mode === "add" ? $t("common.add") : $t("common.update")
              }}</md-button
            >
          </div>
        </div>
      </div>
    </validation-form>
  </div>
</template>
<script>
import { genErrMsgOj, getId, Message } from "@/helpers/utils";
import { validations } from "@/validations/behavior";
import { postFileToS3 } from "@/helpers/aws-s3";
import AWSConst from "@/constants/AWS";
import { service_paths } from "@/constants/Services";
import moment from "moment";
import { Behavior } from "@/constants/Permissions";
export default {
  props: {
    student: {
      default: {}
    },
    modalName: {
      default: ""
    },
    behaviorData: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      Behavior,
      validations: validations,
      termList: [],
      alignments: [
        { id: "Discipline", name: "Discipline" },
        { id: "Tardy", name: "Tardy" },
        { id: "Other", name: "Other" }
      ],
      serverValidations: "",
      file_upload: [],
      behavior: {
        term_id: "",
        student_id: "",
        date_violate: "",
        submitted_by: "",
        location: "",
        event: "",
        injury: "",
        medical_service_provided: "",
        alignment: "Discipline",
        incident_detail: "",
        participant_detail: "",
        file_upload: [],
        resolution: []
      },
      resolution: {
        resolution: "",
        assign_date: "",
        start_date: "",
        end_date: "",
        staff_id: "",
        resolution_detail: ""
      },
      resolutionList: [],
      staffs: {
        label: this.$t("behavior.behavior_staff"),
        value: "",
        displayValue: [],
        options: [],
        fields: {
          text: "name",
          value: "id"
        },
        searchKey: "full_name__~"
      }
    };
  },
  created() {
    this.getTerms();
    if (this.mode === "view") {
      this.behavior = this.behaviorData;
      this.resolutionList = this.behaviorData.resolution;
      this.changeResolutionList();
    }
    if (this.mode === "add") {
      this.behavior.date_violate = moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD HH:mm");
      this.resolutionList.push(this.getNewResolution());
    }
  },
  watch: {
    "behavior.date_violate": function() {
      this.serverValidations.date_violate &&
        delete this.serverValidations.date_violate;
    }
  },
  methods: {
    upLoadFile(e) {
      let fileList = Object.values(e);
      fileList.forEach(async file => {
        let fileUrl = await this.uploadFileToS3(this.changeFileName(file));
        this.file_upload.push({ url: fileUrl, name: file.name });
      });
    },
    changeFileName(file) {
      return new File([file], file.name.replace("-", "_"), { type: file.type });
    },
    uploadFileToS3(file) {
      return postFileToS3(`${AWSConst.S3_STUDENTS_UPLOAD_PATH}/behavior`, file);
    },
    addResolution() {
      this.resolutionList.push(this.getNewResolution());
    },
    removeResolution(index) {
      this.resolutionList.splice(index, 1);
    },
    changeResolutionList() {
      let staffList = [];
      this.resolutionList.forEach(async (resolution, index) => {
        let staff = await this.$axios.get(service_paths.staffs, {
          _id: resolution.staff_id
        });
        staffList.push(
          staff.data.data[0].full_name + " - " + staff.data.data[0].staff_code
        );
      });
      this.staffs.displayValue = staffList;
    },
    buildParam() {
      this.behavior.student_id = getId(this.student);
      if (
        (this.mode === "edit" && this.file_upload.length) ||
        this.mode === "add"
      ) {
        this.behavior.file_upload = this.file_upload.map(files => files.url);
      }
      this.behavior.resolution = this.resolutionList;
    },
    addBehavior() {
      this.$axios
        .post(service_paths.behavior, this.behavior)
        .then(() => {
          this.$emit("reloadData");
          this.$modal.hide(this.modalName);
          Message.success(this.$t("common.add_success"));
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
          }
        });
    },
    editBehavior() {
      this.$axios
        .put(
          `${service_paths.behavior}/${this.behaviorData._id}`,
          this.behavior
        )
        .then(() => {
          this.$modal.hide(this.modalName);
          this.$emit("reloadData");
          Message.success(this.$t("common.update_success"));
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
          }
        });
    },
    fetchBehavior() {
      this.buildParam();
      if (this.mode === "add") {
        this.addBehavior();
      }
      if (this.mode === "edit") {
        this.editBehavior();
      }
    },
    getTerms() {
      this.$axios.get(service_paths.terms).then(res => {
        this.termList = res.data.data;
        this.termList.push({ id: "", name: "None" });
        if (this.mode === "add") {
          this.behavior.term_id = this.termList[0].id;
        }
      });
    },
    getStaffs(param) {
      return this.$axios
        .get(
          service_paths.staffs,
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(res => {
          this.staffs.options = res.data.data.map(staff => ({
            id: staff["_id"],
            name: staff.full_name + " - " + staff.staff_code
          }));
        });
    },
    getNewResolution() {
      return {
        resolution: "",
        assign_date: moment().format("YYYY-MM-DD"),
        start_date: moment().format("YYYY-MM-DD HH:mm"),
        end_date: moment()
          .add(1, "days")
          .format("YYYY-MM-DD HH:mm"),
        staff_id: "",
        resolution_detail: ""
      };
    },
    closeModal() {
      this.$modal.hide(this.modalName);
      this.$emit("reloadData");
    }
  }
};
</script>
<style lang="scss" scoped>
.validation-form {
  .form-actions {
    margin: 12px 0 0 0;
    border-top: 0.5px solid #aaa;
  }
}
.isis-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  .title {
    padding: 0;
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
  button.btn-close {
    padding: 5px 8px;
    border: none;
    background-color: transparent;
    transition: 0.15s;
    cursor: pointer;
    border-radius: 3px;

    &:focus {
      outline: none;
      border: none;
    }

    &:hover {
      background-color: rgba(gray, 0.4);
    }

    i {
      font-size: 16px;
      color: gray;
    }
    i.edit-icon {
      color: green;
    }
    i.view-icon {
      color: #ff9800;
    }
  }
}
</style>
